import { useEffect, useState } from 'preact/hooks';

/**
 * On a phone the page's control bar (tabs, Filters, Sort, Select) slides away as you scroll down
 * and comes back as you scroll up (Kristi, Oct 29, Shelves; every page with one since the check-up,
 * Nov 2). Laptops and iPads keep it pinned. Give the page `tucked` while this is true; the shared
 * CSS in ui.css moves the bar. Only your own scrolling counts: a page that grows as covers load (or
 * a jump to a letter) isn't you.
 */
export function useTuck(wide: boolean): boolean {
  const [tucked, setTucked] = useState(false);
  useEffect(() => {
    if (wide) {
      setTucked(false);
      return;
    }
    let last = window.scrollY;
    let height = document.documentElement.scrollHeight;
    let moved = 0;
    let quiet = 0; // scroll steps to let pass after a change (the bar's own slide)
    let cur = false;
    const on = () => {
      const y = window.scrollY;
      const h = document.documentElement.scrollHeight;
      if (y < 120) {
        cur = false;
        setTucked(false); // near the top, always shown
      }
      if (h !== height) {
        height = h;
        last = y;
        moved = 0;
        return;
      }
      if (y < 120) {
        moved = 0;
      } else {
        moved = Math.sign(y - last) === Math.sign(moved) ? moved + (y - last) : y - last;
        const want = moved > 40 ? true : moved < -20 ? false : cur;
        if (quiet > 0) quiet--;
        else if (want !== cur) {
          cur = want;
          setTucked(want);
          quiet = 2;
        }
        if (want === cur) moved = Math.sign(moved) * Math.min(Math.abs(moved), 60);
      }
      last = y;
    };
    window.addEventListener('scroll', on, { passive: true });
    return () => window.removeEventListener('scroll', on);
  }, [wide]);
  return tucked;
}
